import React from "react";

import clsx from "clsx";

import CircularProgress from "@busbud/design-system-components/dist/CircularProgress";
import { Label } from "@busbud/horizon";

import { useAppContext } from "@app/helpers/hooks";

interface Props {
  class_name?: string;
}

export const LoadingBusLayout: React.FC<Props> = ({ class_name }) => {
  const { translator } = useAppContext();

  return (
    <div
      className={clsx(
        class_name,
        "flex flex-col items-center justify-center gap-100 p-200"
      )}
    >
      <Label size="md" className="text-color-secondary" as="p">
        {translator.t("!checkout.seat-selection.loading-bus-layout")}
      </Label>
      <CircularProgress />
    </div>
  );
};
